// extracted by mini-css-extract-plugin
export default {"Container":"alarmScrollBox_Container__mPeuq","scrollableContainer":"alarmScrollBox_scrollableContainer__dau1B"};